import React, { useEffect, useState } from 'react';
import styles from '../../vendor/dashboard/VendorNewDashboard.module.css';
import vendorThumb from 'routes/vendorRe/images/vendor_thumb.png';
import allGreen from 'routes/vendorRe/images/all_green.png';
import allError from 'routes/vendorRe/images/all_error.png';
import { useNavigate } from 'react-router-dom';

const VendorInfoList = (props) => {
    const { data } = props;
    const [store, setStore] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        if (props.data) {
            setStore(data);
        }
    }, [props]);

    const onStoreDetailClick = () => {
        if (props.url) {
            navigate(props.url, { state: { data: store } });
        } else {
            navigate(`/vendor/main/detail/${store.id}`, { state: { data: store } });
        }
    };

    return (
        <div className={styles.storeInfoCard}>
            <div className={styles.storeInfoHeader}>
                <div className={styles.storeInfoLeft}>
                    <img 
                        className={styles.storeThumb} 
                        src={vendorThumb} 
                        alt='점포 썸네일' 
                    />
                    <div className={styles.storeInfoContent}>
                        <div className={styles.storeInfoName}>
                            {data && data.storeName}
                        </div>
                        <div className={styles.storeInfoId}>
                            ID: {data && data.id}
                        </div>
                    </div>
                </div>
                <button 
                    className={styles.detailButton}
                    style={{width: "20%"}}
                    onClick={onStoreDetailClick}
                >
                    {`상세`}
                </button>
            </div>

            <div className={styles.storeInfoBody}>
                <div className={styles.deviceStatus}>
                    <div className={styles.deviceTitle}>키오스크 상태</div>
                    <div className={styles.deviceGrid}>
                        {store && store.machines
                            .filter(machine => machine.orderNo === 1 || machine.orderNo === 2)
                            .map((kiosk, index) => (
                                <div key={index} className={styles.deviceItem}>
                                    <img 
                                        className={styles.statusIcon} 
                                        src={kiosk.heartbeat ? allGreen : allError} 
                                        alt={kiosk.heartbeat ? '정상' : '오류'} 
                                    />
                                    <span className={`${styles.statusText} ${kiosk.heartbeat ? styles.success : styles.error}`}>
                                        {kiosk.heartbeat ? '정상' : '오류'}
                                    </span>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorInfoList;